"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * English localization
 */
exports.default = {
    didNotBackUpWallet: "If you didn't backup your certificate, or you lost your phone, contact support @TicketheadSupport.",
    nft: 'Head',
};
//# sourceMappingURL=en.js.map